import { get } from 'http'
import querystring from 'querystring'
import AirportCodesData from '../airportJson/AirportCodesData'
import { getCookie } from 'utils'
export const readParam = (name) => {
    const queryString = window.location.search.split('?')
    const urlHash = fromQueryString(queryString[1] ? queryString[1] : '')
    const params = urlHash ? urlHash : {}
    const value = params[name] || ''
    return value
}

export const fromQueryString = (queryString, sep = '&', eq = '=') => {
    return querystring.parse(queryString, sep, eq)
}

export const capitalizeFirst = (str) => {
    return str.split(' ').map(str => str.charAt(0).toUpperCase() + str.slice(1)).join(' ');
}
export  async function airportCodes()
{
  let query = new URLSearchParams(window.location.search);
  let CityList=[];
  let CityList2=[];
  CityList2[0]=query.get("from").toUpperCase()
  CityList2[1]=query.get("to").toUpperCase()
  let name,iso2Code,iso3Code,codesObject;
  var responseFinalData;
  const twoLetterCountryCode=AirportCodesData;
  for(var i=0;i<2;i++)
  {
  const response=await fetch(`https://platform.cleartrip.com/aircon-api/places/airports/search?string=${CityList2[i]}`)
   const responseData=await response.json()
   responseData.map((obj)=>{
    if((obj.k)==(CityList2[i])){//k stands for specific key
        responseFinalData=obj;
      return;
    }
  });
     name=(responseFinalData.v).split(",")[0].trim();//v stands for value of related key
     iso2Code=((responseFinalData.v).split(",")[1]).split(" ")[1]
     twoLetterCountryCode.map((countryCode) => {
      if(countryCode.AlphaTwo===iso2Code)
      {
       iso3Code=countryCode.AlphaThree;
       return;
      }
    });
    codesObject={
    "name":name,
    "iso2Code": iso2Code,
    "iso3Code": iso3Code,
  };
    CityList.push(codesObject);
}
const fromIso3=CityList[0].iso3Code
const toIso3=CityList[1].iso3Code
return [fromIso3,toIso3]
}

export function filterBeforeArrival(restrictions, origin, fromParamsOrigin) {
  restrictions = restrictions.filter((r) => {
    if(r.attributes.country === origin || r.attributes.country === fromParamsOrigin.current) {
      return false;
    }

    if (r.type === "PROCEDURE") {
      return (
        r.attributes.subCategory !== "ON_ARRIVAL" &&
        r.attributes.subCategory !== "DOMESTIC"
      );
    }

    if (r.type === "RESTRICTION") {
      return r;
    }
  });
  return restrictions;
}

export function filterOnArrival(restrictions, origin, fromParamsOrigin) {
  restrictions = restrictions.filter((r) => {
    if(r.attributes.country === origin || r.attributes.country === fromParamsOrigin.current) {
      return false;
    }

    if (r.type === 'PROCEDURE') {
      return r.attributes.subCategory === 'ON_ARRIVAL' || r.attributes.subCategory === 'DOMESTIC'
    }
  })
  return restrictions;
}

export function filterOnReturn(restrictions, origin, fromParamsOrigin) {
  restrictions = restrictions.filter((r) => {
    if(r.attributes.country === origin || r.attributes.country === fromParamsOrigin.current) {
      return true;
    }
  })
  return restrictions;
}

const TRAVEL_RESTRICTIONS = ["QUARANTINE", "NO_QUARANTINE", "COVID_19_TEST", "NO_COVID_19_TEST", "HEALTH_MEASURES", "RE_ENTRY_PERMIT", "HEALTH_INSURANCE", "TRAVEL_INSURANCE"];
const ADDITIONAL_INFO = ["PPE", "HEALTH_ASSESSMENT", "SANITIZATION", "DEPOSIT_REQUIRED"];
const dateformatOptions = { month: 'short', day: 'numeric', year: 'numeric' };

export function filterTravelRestrictions(restrictions, country, paramsCountry = '') {
  restrictions = restrictions.filter((r) => {
    if((r.attributes.country === country || r.attributes.country === paramsCountry)) {
      if(r.type === "RESTRICTION") {
        return true;
      } else if(r.type === "PROCEDURE" && TRAVEL_RESTRICTIONS.includes(r.attributes.category)) {
        return true;
      }
    }
  });
  const dates = restrictions.map((item) => !item.attributes.lastUpdatedAt ? "" : item.attributes.lastUpdatedAt);
  dates.sort();
  let date = new Date(dates[dates.length - 1]).toLocaleDateString('en', dateformatOptions);
  if(date === 'Invalid Date') {
    return {restrictions, date: ''};
  }
  // date = date.substr(4, date.length);
  return {restrictions, date};
}

export function filterFormsAndDocs(restrictions, country, paramsCountry = '') {
  restrictions = restrictions.filter((r) => {
    if((r.attributes.country === country || r.attributes.country === paramsCountry) && r.type === "PROCEDURE") {
      return r.attributes.category === "DOC_REQUIRED";
    }
  });
  const dates = restrictions.map((item) => !item.attributes.lastUpdatedAt ? "" : item.attributes.lastUpdatedAt);
  dates.sort();
  let date = new Date(dates[dates.length - 1]).toLocaleDateString('en', dateformatOptions);
  if(date === 'Invalid Date') {
    return {restrictions, date: ''};
  }
  // date = date.substr(4, date.length);
  return {restrictions, date};
}

export function filterAdditionalInfo(restrictions, country, paramsCountry = '') {
  restrictions = restrictions.filter((r) => {
    if((r.attributes.country === country || r.attributes.country === paramsCountry)) {
      if(r.type === "PROCEDURE" && ADDITIONAL_INFO.includes(r.attributes.category)) {
        return true;
      }
    }
  });
  const dates = restrictions.map((item) => !item.attributes.lastUpdatedAt ? "" : item.attributes.lastUpdatedAt);
  dates.sort();
  let date = new Date(dates[dates.length - 1]).toLocaleDateString('en', dateformatOptions);
  if(date === 'Invalid Date') {
    return {restrictions, date: ''};
  }
  // date = date.substr(4, date.length);
  return {restrictions, date};
}

export const getBodyForTrip = (tripType, origin, destination, ActiveDate, onwardLayover, returnLayover, isVaccinated, originDate, destinatonDate) => {
  const date = new Date(originDate);
  const fromMonth = (1 + date.getMonth()) >= 1 &&  (1 + date.getMonth()) <= 9 ? '0' + (1 + date.getMonth()) : (1 + date.getMonth());
  const fromDate = date.getDate()  >= 1 &&  date.getDate() <= 9 ? '0' + date.getDate() : date.getDate();
  let from = date.getFullYear() + "-" + fromMonth + "-" + fromDate;
  let to = ''
  if(destinatonDate) {
    const date = new Date(destinatonDate);
    const toMonth = (1 + date.getMonth()) >= 1 &&  (1 + date.getMonth()) <= 9 ? '0' + (1 + date.getMonth()) : (1 + date.getMonth());
    const toDate = date.getDate()  >= 1 &&  date.getDate() <= 9 ? '0' + date.getDate() : date.getDate();
    to = date.getFullYear() + "-" + toMonth + "-" + toDate;
  }
  let body;
  const vaccinated = isVaccinated ? "FULLY_VACCINATED" : "NOT_VACCINATED";
  if(tripType === 'ONE_WAY_TRIP') {
    if(onwardLayover.code) {
      body = {
        data: {
          type: "TRIP",
          attributes: {
            category: tripType,
            segments: [
              {
                segmentType: "OUTBOUND",
                segmentSubType: "TRANSIT",
                origin: {
                  countryCode: origin,
                },
                destination: {
                  countryCode: onwardLayover.code,
                },
                departureDate: from || ActiveDate,
                departureTime: "00:00",
                arrivalDate: from || ActiveDate,
                arrivalTime: "00:00",
                travelMode: "AIR"
              },
              {
                segmentType: "OUTBOUND",
                origin: {
                  countryCode: onwardLayover.code,
                },
                destination: {
                  countryCode: destination,
                },
                departureDate: from || ActiveDate,
                departureTime: "00:00",
                arrivalDate: from || ActiveDate,
                arrivalTime: "00:00",
                travelMode: "AIR"
              }
            ],
            travellers: [
              {
                vaccinations: [
                  {
                    type: "COVID_19",
                    status: vaccinated,
                  },
                ],
                nationality: "IND",
              },
            ],
          },
        },
      }
    } else {
      body = {
        data: {
          type: "TRIP",
          attributes: {
            category: tripType,
            segments: [
              {
                segmentType: "OUTBOUND",
                origin: {
                  countryCode: origin,
                },
                destination: {
                  countryCode: destination,
                },
                departureDate: from || ActiveDate,
                departureTime: "00:00",
                arrivalDate: from || ActiveDate,
                arrivalTime: "00:00",
                travelMode: "AIR"
              }
            ],
            travellers: [
              {
                vaccinations: [
                  {
                    type: "COVID_19",
                    status: vaccinated,
                  },
                ],
                nationality: "IND",
              },
            ],
          },
        },
      };
    }
  } else {
    if(onwardLayover.code && returnLayover.code) {
      body = {
        data: {
          type: "TRIP",
          attributes: {
            category: tripType,
            segments: [
              {
                segmentType: "OUTBOUND",
                segmentSubType: "TRANSIT",
                origin: {
                  countryCode: origin,
                },
                destination: {
                  countryCode: onwardLayover.code,
                },
                departureDate: from || ActiveDate,
                departureTime: "00:00",
                arrivalDate: from || ActiveDate,
                arrivalTime: "00:00",
                travelMode: "AIR",
              },
              {
                segmentType: "OUTBOUND",
                origin: {
                  countryCode: onwardLayover.code,
                },
                destination: {
                  countryCode: destination,
                },
                departureDate: from || ActiveDate,
                departureTime: "00:00",
                arrivalDate: from || ActiveDate,
                arrivalTime: "00:00",
                travelMode: "AIR",
              },
              {
                segmentType: "RETURN",
                segmentSubType: "TRANSIT",
                origin: {
                  countryCode: destination,
                },
                destination: {
                  countryCode: returnLayover.code,
                },
                departureDate: to || ActiveDate,
                departureTime: "00:00",
                arrivalDate: to || ActiveDate,
                arrivalTime: "00:00",
                travelMode: "AIR",
              },
              {
                segmentType: "RETURN",
                origin: {
                  countryCode: returnLayover.code,
                },
                destination: {
                  countryCode: origin,
                },
                departureDate: to || ActiveDate,
                departureTime: "00:00",
                arrivalDate: to || ActiveDate,
                arrivalTime: "00:00",
                travelMode: "AIR",
              },
            ],
            travellers: [
              {
                vaccinations: [
                  {
                    type: "COVID_19",
                    status: vaccinated,
                  },
                ],
                nationality: "IND",
              },
            ],
          },
        },
      }
    } else if(!onwardLayover.code && returnLayover.code) {
      body = {
        data: {
          type: "TRIP",
          attributes: {
            category: tripType,
            segments: [
              {
                segmentType: "OUTBOUND",
                origin: {
                  countryCode: origin,
                },
                destination: {
                  countryCode: destination,
                },
                departureDate: from || ActiveDate,
                departureTime: "00:00",
                arrivalDate: from || ActiveDate,
                arrivalTime: "00:00",
                travelMode: "AIR",
              },
              {
                segmentType: "RETURN",
                segmentSubType: "TRANSIT",
                origin: {
                  countryCode: destination,
                },
                destination: {
                  countryCode: returnLayover.code,
                },
                departureDate: to || ActiveDate,
                departureTime: "00:00",
                arrivalDate: to || ActiveDate,
                arrivalTime: "00:00",
                travelMode: "AIR",
              },
              {
                segmentType: "RETURN",
                origin: {
                  countryCode: returnLayover.code,
                },
                destination: {
                  countryCode: origin,
                },
                departureDate: to || ActiveDate,
                departureTime: "00:00",
                arrivalDate: to || ActiveDate,
                arrivalTime: "00:00",
                travelMode: "AIR",
              },
            ],
            travellers: [
              {
                vaccinations: [
                  {
                    type: "COVID_19",
                    status: vaccinated,
                  },
                ],
                nationality: "IND",
              },
            ],
          },
        },
      }
    } else if(onwardLayover.code && !returnLayover.code) {
      body = {
        data: {
          type: "TRIP",
          attributes: {
            category: tripType,
            segments: [
              {
                segmentType: "OUTBOUND",
                segmentSubType: "TRANSIT",
                origin: {
                  countryCode: origin,
                },
                destination: {
                  countryCode: onwardLayover.code,
                },
                departureDate: from || ActiveDate,
                departureTime: "00:00",
                arrivalDate: from || ActiveDate,
                arrivalTime: "00:00",
                travelMode: "AIR",
              },
              {
                segmentType: "OUTBOUND",
                origin: {
                  countryCode: onwardLayover.code,
                },
                destination: {
                  countryCode: destination,
                },
                departureDate: from || ActiveDate,
                departureTime: "00:00",
                arrivalDate: from || ActiveDate,
                arrivalTime: "00:00",
                travelMode: "AIR",
              },
              {
                segmentType: "RETURN",
                origin: {
                  countryCode: destination,
                },
                destination: {
                  countryCode: origin,
                },
                departureDate: to || ActiveDate,
                departureTime: "00:00",
                arrivalDate: to || ActiveDate,
                arrivalTime: "00:00",
                travelMode: "AIR",
              },
            ],
            travellers: [
              {
                vaccinations: [
                  {
                    type: "COVID_19",
                    status: vaccinated,
                  },
                ],
                nationality: "IND",
              },
            ],
          },
        },
      }
    } else {
      body = {
          data: {
            type: "TRIP",
            attributes: {
              category: tripType,
              segments: [
                {
                  segmentType: "OUTBOUND",
                  origin: {
                    countryCode: origin,
                  },
                  destination: {
                    countryCode: destination,
                  },
                  departureDate: from || ActiveDate,
                  departureTime: "00:00",
                  arrivalDate: from || ActiveDate,
                  arrivalTime: "00:00",
                  travelMode: "AIR",
                },
                {
                  segmentType: "RETURN",
                  origin: {
                    countryCode: destination,
                  },
                  destination: {
                    countryCode: origin,
                  },
                  departureDate: to || ActiveDate,
                  departureTime: "00:00",
                  arrivalDate: to || ActiveDate,
                  arrivalTime: "00:00",
                  travelMode: "AIR",
                },
              ],
              travellers: [
                {
                  vaccinations: [
                    {
                      type: "COVID_19",
                      status: vaccinated,
                    },
                  ],
                  nationality: "IND",
                },
              ],
            },
          },
      };
    }
  }
  return body
}

export const filterReturnData = (response, country) => {
  const travelRestrictions = filterTravelRestrictions(response.included, country);
  const formsAndDocs = filterFormsAndDocs(response.included, country);
  const additionalInfo = filterAdditionalInfo(response.included, country);
  return {travelRestrictions, formsAndDocs, additionalInfo};
}
export const isUserSignedIn = () => {
  let userObject = getUserAuthValues() || {}
  let usermiscVal = decodeURIComponent(getCookie('usermisc') || '').split('|')
  let signedIn =
      usermiscVal.includes('SIGNED_IN') && getCookie('ct-auth') && userObject.userId && userObject.userId.length > 0
          ? true
          : false

  return signedIn
}
export function getUserAuthValues() {
  const [email, profileName, gender, photo, userId] = decodeURIComponent(getCookie('userid') || '').split('|')
  return {
      email,
      profileName,
      gender,
      photo,
      userId
  }
  }
